import { render } from "./BtnAlternativoTransparente.vue?vue&type=template&id=73c7ef44&scoped=true"
import script from "./BtnAlternativoTransparente.vue?vue&type=script&lang=js"
export * from "./BtnAlternativoTransparente.vue?vue&type=script&lang=js"

import "./BtnAlternativoTransparente.vue?vue&type=style&index=0&id=73c7ef44&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c7ef44"]])

export default __exports__